import { useContext } from 'react';
import { useOptimizelyFeature } from '@atc/optimizely-toolkit';
import Context from './Context';
import getFeature from './getFeature';
export default function useFeature(featureKey) {
  const featuresContext = useContext(Context) || {};
  const optimizely = useOptimizelyFeature();
  return getFeature(featureKey, {
    featuresContext,
    optimizely
  });
}